import classNames from 'classnames';
import { ReactNode } from 'react';
import useStyles from './Footer.styles';

export interface IFooterProps {
  /** Content that is displayed by this component. */
  children: ReactNode;
  /** CSS classes applied to the root element of this component. */
  className?: string;
  /** Html id attribute applied to the root element of this component. */
  htmlId?: string;
  /** Controls whether footer is static on bottom of screen */
  sticky?: boolean;
}

const Footer = ({ children, className, htmlId, sticky }: IFooterProps) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className, { [classes.sticky]: sticky })} id={htmlId}>
      {children}
    </div>
  );
};

export default Footer;
